import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { updateSelectedMetric } from '../../actions/wellness'
import { withTranslation } from '../../translations'
import currentScanSelector from '../../selectors/current_scan'

import SubNavContainer from '../../components/navbar/sub_nav_container'
import NavItem from '../../components/navbar/nav_item'
import SubNav from '../../components/navbar/sub_nav'

// images: 'report-images-grid',
// wellnessGrid: 'report-wellness-grid',
// postureGrid: 'report-posture-grid',
// balanceGrid: 'report-balance-grid',
// measurementGrid: 'report-measurements-grid'

// NOTE: store elemtn id in reducer here, so we can handle scrolling on wellness report page instead of here
class FitnessNav extends Component {
  constructor(props) {
    super(props)
    this.clickHandler = this.clickHandler.bind(this)
  }

  // displayGrid is a bool to show if the grid is even available. don't want to re-render wellness component if the component doesn't even exist
  clickHandler(id, displayGrid) {
    if (this.props.pathname !== '/wellness') {
      this.props.updateSelectedMetric(id)
      this.props.redirectPage('/wellness')()
    } else if (this.props.pathname === '/wellness' && displayGrid) {
      this.props.updateSelectedMetric(id)
    }
  }

  render() {
    const selectedMetric = this.props.wellness.get('selectedMetric')
    const report = this.props.wellness.get('report')
    const hwVersion = this.props.currentScan
      ? this.props.currentScan.get('hwVersion')
      : 0

    const t = this.props.t
    const resultsSubNav = [
      {
        text: t('nav.scan'),
        clickHandler: () => this.clickHandler('report-images-grid', !!report),
        isSelected: selectedMetric === 'report-images-grid' && !!report,
      },
      {
        text: t('nav.wellness'),
        clickHandler: () =>
          this.clickHandler(
            'report-wellness-grid',
            !!(report && report.get('wellnessMetrics'))
          ),
        isSelected:
          selectedMetric === 'report-wellness-grid' &&
          !!(report && report.get('wellnessMetrics')),
      },
      {
        text: t('nav.posture'),
        clickHandler: () =>
          this.clickHandler(
            'report-posture-grid',
            !!(report && report.get('posture'))
          ),
        isSelected:
          selectedMetric === 'report-posture-grid' &&
          !!(report && report.get('posture')),
      },
      {
        id: 'balance',
        text: t('nav.balance'),
        clickHandler: () =>
          this.clickHandler(
            'report-balance-grid',
            !!(report && report.get('balance'))
          ),
        isSelected:
          selectedMetric === 'report-balance-grid' &&
          !!(report && report.get('balance')),
      },
      {
        text: t('nav.measurements'),
        clickHandler: () =>
          this.clickHandler(
            'report-measurements-grid',
            !!(report && report.get('measurements'))
          ),
        isSelected:
          selectedMetric === 'report-measurements-grid' &&
          !!(report && report.get('measurements')),
      },
      {
        text: t('nav.printable'),
        clickHandler: this.props.redirectPage('/report'),
        isSelected: this.props.pathname === '/report',
      },
    ].filter((item) => item.id !== 'balance' || hwVersion !== 7)

    const comparisonSubNav = [
      {
        text: t('nav.wellness'),
        clickHandler: this.props.redirectPage('/comparison/wellness'),
        isSelected: this.props.pathname === '/comparison/wellness',
      },
      {
        text: t('nav.measurements'),
        clickHandler: this.props.redirectPage('/comparison/measurements'),
        isSelected: this.props.pathname === '/comparison/measurements',
      },
      {
        text: t('nav.posture'),
        clickHandler: this.props.redirectPage('/comparison/posture'),
        isSelected: this.props.pathname === '/comparison/posture',
      },
      {
        text: t('nav.printable'),
        clickHandler: this.props.redirectPage('/report/comparison'),
        isSelected: this.props.pathname === '/report/comparison',
      },
    ]

    const isResultPageSelected =
      this.props.selectedSubPage === 'fitnessResults' ||
      this.props.pathname === '/wellness' ||
      this.props.pathname === '/report'
    const isComparisonSelected =
      this.props.selectedSubPage === 'fitnessComparison' ||
      this.props.pathname.indexOf('/comparison') !== -1
    const isGlossarySelected = this.props.pathname === '/glossary'

    return (
      <SubNavContainer header={t('nav.fitness')}>
        <ul
          className="nav-pills flex-md-column list-unstyled"
          style={{ padding: '15px 0px' }}
        >
          <NavItem
            isSelected={isResultPageSelected}
            text={t('nav.results')}
            clickHandler={this.props.redirectPage('/wellness')}
          >
            <SubNav subNavProps={resultsSubNav} />
          </NavItem>
          <NavItem
            isSelected={isComparisonSelected}
            text={t('nav.comparison')}
            clickHandler={this.props.redirectPage('/comparison/wellness')}
          >
            <SubNav subNavProps={comparisonSubNav} />
          </NavItem>
          <NavItem
            isSelected={isGlossarySelected}
            text={t('nav.glossary')}
            clickHandler={this.props.redirectPage('/glossary')}
          />
        </ul>
      </SubNavContainer>
    )
  }
}

FitnessNav.propTypes = {
  wellness: ImmutablePropTypes.contains({
    selectedMetric: PropTypes.string,
    report: ImmutablePropTypes.map,
  }).isRequired,
  pathname: PropTypes.string.isRequired,
  selectedSubPage: PropTypes.string,
  updateSelectedMetric: PropTypes.func.isRequired,
  redirectPage: PropTypes.func.isRequired,
  currentScan: ImmutablePropTypes.map,
  t: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  wellness: state.wellness,
  currentScan: currentScanSelector(state),
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ updateSelectedMetric }, dispatch)

export default withTranslation(
  connect(mapStateToProps, mapDispatchToProps)(FitnessNav)
)
